<template>
  <span class="zfkanban-active">
    <div class="box">
      <div class="lfet">
        <div class="b">
          <div class="titles">低碳智慧能源运营管理平台</div>
          <div class="line"></div>
          <div class="text">低碳智慧能源运营管理平台(Low-Carbon Smart Energy Operation Management Platform)
            是面向企业能源智慧化、低碳化运营需求的综合性管理系统，旨在通过先进的信息技术包括:物联网、大数据、云计算、人工智能等技术手段帮助企业进行能源的有效管理、实现节能降碳、效益增收和低碳运行，平台具有优化能源生产和消费过程，提高能源利用效率，减少碳排放，支持企业可持续运营与发展。
          </div>
        </div>
        <div class="img">
          <img src="./pay.png" alt="">
          <span>三重科技</span>
        </div>

      </div>
      <div class="right">
        <div class="loginContent">
          <span class="tited">欢迎登录</span>
          <span class="login_p">请输入登录账号与密码</span>

          <el-form :model="temp" :rules="rules" ref="temp" label-position="top" class="demo-temp">
            <el-form-item label="账号" prop="userCode" style="margin-bottom: 32px;">
              <el-input class="inputedss" v-model="temp.userCode" placeholder="请输入账号" @keyup.enter="submit"
                autofocus></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" style="position: relative;">
              <el-input class="inputedss" placeholder="请输入密码" v-model="temp.password" :type="pasType"
                @keyup.enter.native="submit"></el-input>
              <img class="imged" src="@/assets/eye.png" v-if="pasType == 'password'" @click="pasType='text'">
              <img class="imged" src="@/assets/eye2.png" v-else @click="pasType='password'">
            </el-form-item>
            <el-checkbox v-model="checked" style="margin-top: 5px;" text-color="red">记住密码</el-checkbox>
          </el-form>
          <span id="loginSpan" class="loginButton" @click="submit">登 录</span>
        </div>
      </div>
    </div>

    <div v-show="copyRightIsDisplay" class="information flexCenterColumn">
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightinfo }}</a>
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightNumber }}</a>
    </div>
  </span>

</template>

<script>
  import request from "@/api/http.js";
  export default {
    data() {
      return {
        copyRight: {
          rightinfo: "",
          rightNumber: "",
        },
        copyRightUrl: undefined,
        copyRightIsDisplay: true, //是否展示copyright
        pasType: 'password',
        temp: {
          userCode: '',
          password: ''
        },
        checked: false,
        rules: {
          userCode: { required: true, message: '请输入账号', trigger: 'blur' },
          password: { required: true, message: '请输入密码', trigger: 'blur' },
        },
        item: '',

        diaStatus: false,
        fangFlag: true,

      };
    },


    mounted() {
      if (localStorage.getItem('checked')) {
        this.checked = true;//保存登陆时间
        this.temp.password = localStorage.getItem('password') || '';//保存登陆时间
        this.temp.userCode = localStorage.getItem('userCode') || '';//保存登陆时间
      }

            //设置版权声明
     this.copyRight=DWSystemSetting.copyRight;
      this.copyRightUrl=DWSystemSetting.copyRightUrl;
      if(DWSystemSetting.copyRightIsDisplay!=undefined) {
        this.copyRightIsDisplay=DWSystemSetting.copyRightIsDisplay;
      } else {
        this.copyRightIsDisplay=true;
      }
   
    },
    methods: {
      urlGo(c, b) {
        var time = localStorage.getItem('loginTime');//上次登陆时间 
        var d = new Date().getTime();//当前时间 

        this.item = c;
        if (!time) {//没有登陆时间
          this.diaStatus = true;
          return
        };
        if ((d - time) > 86400000) {//超过一天
          this.diaStatus = true;
          return
        }
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });


      },
      submit() {

        this.$refs['temp'].validate((valid) => {
          if (valid) {

          }
        })

        if (!this.temp.userCode) {
          this.$message({ message: '请输入账号', type: 'info' });
          return
        }
        if (!this.temp.password) {
          this.$message({ message: '请输入密码', type: 'info' });
          return
        }
        if (this.temp.userCode != '1') {
          this.$message({ message: '账号错误', type: 'info' });
          return
        }
        if (this.temp.password != '1') {
          this.$message({ message: '密码错误', type: 'info' });
          return
        }

        localStorage.setItem('loginTime', new Date().getTime());//保存登陆时间
        this.$message({ message: '登陆成功', type: 'success' });
        this.$router.push('/pingtai')
        if (this.checked) {
          localStorage.setItem('password', this.temp.password);//保存登陆时间
          localStorage.setItem('userCode', this.temp.userCode);//保存登陆时间
          localStorage.setItem('checked', this.checked);//保存登陆时间
        }


      }
    },
    filters: {
      // 转换时间戳
      "date_format": function (value) { //value就是插值的数据
        if (!value) {
          return ""
        }
        let date = new Date(value);
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

        let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
        let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
        let strDate = M + D + " " + h + m;
        return strDate
      },
    }
  };
</script>
<style>
  .zfkanban-active .box .el-form-item__label {
    font-size: 16px;
    color: #333;
  }

  .zfkanban-active .box .el-form-item__label {
    line-height: inherit;
  }

  .zfkanban-active .box .el-input__inner {
    border-radius: 8px !important;
    height: 48px;
    font-size: 18px;
  }

  .zfkanban-active .box .el-checkbox__input.is-checked .el-checkbox__inner,
  .zfkanban-active .box .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #195fce;
    /* 你想要的选中颜色 */
    border-color: #195fce;
  }

  .zfkanban-active .box .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #195fce;
  }
</style>
<style scoped>
  .information {
    position: absolute;
    z-index: 1;
    bottom: 20px;
    width: 99%;
    box-sizing: border-box;
  }

  .information>a {
    display: block;
    color: #fff;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
  }
  .imged {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
  }

  .inputedss {
    height: 48px;
  }

  .login_p {
    color: #666;
    font-size: 14px;
    margin-top: 7px;
    text-align: center;
    margin-bottom: 20px;
  }

  .tited {
    font-family: Microsoft YaHei;
    font-weight: normal;
    font-weight: bold;
    width: 100%;
    text-align: center;
    font-size: 24px;
    color: #195FCE;
    margin-bottom: 4px;
  }

  #loginSpan {
    margin: 10px auto;
    width: 100%;
    margin-top: 14px;
    background: #0052CC;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    border-radius: .08rem;
    cursor: pointer;
    margin-top: 39px;
    color: #fff;
  }

  .flexStart {
    border: 2px solid #1d90d6;
    margin: 8px 20px;
    padding-left: 10px;
  }

  .loginContent .p {
    font-family: monospace;
    font-size: 9pt;
    text-align: center;
    padding-top: 10px;
    color: #969349 !important;
    white-space: nowrap;
    margin-bottom: 28px;
  }

  .loginContent .tit {
    text-align: center;
    font-size: 20px;
    margin-top: 18px;
    margin-bottom: 14px;
  }



  .loginContent {
    color: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    width: 400px;
    height: 482px;
    border-radius: 4px;
    background: #FFF;
    box-sizing: border-box;
    padding: 40px;
  }

  .ul {
    position: absolute;
    left: 21%;
    top: 14%;
    width: 48%;
    height: 569px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .ul .li {
    height: 18%;
    width: 21%;
    margin-bottom: 53px;
  }

  .temp2 {
    height: auto !important;
    margin: 0;
    background: url('http://39.101.131.179:9092/resources/icons/background.png') no-repeat !important;
    background-size: 100% 100% !important;
    width: 100vw !important;
    height: 100vh !important;
  }
</style>
<style lang="scss" scoped>
  .content {
    display: flex;
    background-color: #FFF;
    flex-direction: column;
    padding-bottom: .6rem;

    .c_box {
      display: flex;
    }

    .c_tit {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: .24rem;
      margin-top: .6rem;
      margin-bottom: .08rem;
    }

    .c_p {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: .14rem;
      width: 7.2rem;
      line-height: .22rem;
      margin-bottom: .15rem;
    }

    .c_ul {
      border-radius: .06rem .06rem 0px 0px;
      overflow: hidden;
      width: 32%;
      border-radius: .06rem;
      background: #FFF;
      border: 1px solid #E6E6E6;
      padding-bottom: .18rem;
      position: relative;
      cursor: pointer;
      margin-right: .13rem;



      .span {
        position: absolute;
        top: 0;
        width: 100%;
        height: 1.9rem;
        background-color: #1a1a1a94;
        text-align: center;
        line-height: 1.9rem;
        color: #FFF;
        font-size: .2rem;
        display: none;
      }

      .tt {
        color: #1A1A1A;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: .16rem;
        margin-bottom: .08rem;
        padding-left: .2rem;
      }

      .pp {
        color: #666;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: .16rem;
        padding-left: .2rem;
      }

      .box {
        width: 100%;

        height: 1.9rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: .18rem;

        img {
          width: .72rem;
          height: .72rem;
        }
      }

    }

    .c_ul:nth-child(4) {
      margin-right: 0;
    }

    .c_ul:hover {
      box-shadow: 0px .06rem .12rem 0px #66666630;

      .span {
        display: block;
      }
    }
  }

  .p1 {
    height: 2rem;
    width: 100%;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    .t {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: .32rem;
      margin-bottom: .12rem;
    }

    .txt {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: .16rem;
    }
  }

  .t_box {
    width: 12rem;
    margin: 0 auto;
  }

  .tit {
    background: #FFF;
    box-shadow: 0px .04rem .08rem 0px #66666619;
    height: .62rem;
    width: 100%;
    display: flex;
    align-items: center;

    .tit_li {
      border-radius: .06rem;
      background: #0052CC;
      width: .88rem;
      height: .37rem;
      color: #FFF;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: .16rem;
      cursor: pointer;
      text-align: center;
      line-height: .37rem;
    }
  }

  .zfkanban {
    padding: 0px !important;
  }

  .zfkanban-active {
    position: fixed;
    top: 0;
    left: 0;
    margin-top: 0px !important;
    height: 100% !important;
    z-index: 1;
  }
</style>

<style lang="scss" scoped>
  .box {
    display: flex;
    padding-top: 100px;
    padding-left: 100px;
    padding-right: 100px;
    color: #fff;
    box-sizing: border-box;
    height: 100%;

    .right {
      display: flex;
      justify-content: end;
      flex: 1;
      margin-top: 7%;
    }

    .lfet {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .b {


        .line {
          width: 40px;
          height: 5px;
          background-color: #156FFF;
          margin: 20px 0;
        }

        .text {
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: normal;
          width: 600px;
          line-height: 20px;
        }
      }
    }

    .titles {
      font-family: Microsoft YaHei;
      font-size: 50px;
      font-weight: bold;
    }

    .line {}

    .img {
      display: flex;
      font-family: Microsoft YaHei;
      display: flex;
      align-items: center;
      margin-bottom: 100px;

      span {
        font-size: 24px;
      }

      img {
        margin-right: 8px;
      }
    }
  }

  .zfkanban {
    padding: 0px !important;
  }

  .zfkanban-active {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #78757a !important;
    background: url('./bg2.png');
    background-size: 100% 100%;
    margin-top: 0px !important;
    height: 100% !important;
    z-index: 1;
  }
</style>